import Config from "@/mx-configs/mx.locale.config";
import device from "../utils/device";
const langs = {
  "zh-CN": ["zh-cn", "cn", "zh"],
  "ja-JP": ["ja-jp", "ja", "jp"],
  "en-US": ["en-us", "en", "us"],
};

const langKeys = Object.keys(langs);

let currentLang = langKeys[0];

/**
 *
 * @description 根据语言标识获取对应的语言类型
 * @param {*} [lang=langKeys[0]]
 * @returns
 */
function getLangType(lang = langKeys[0]) {
  if (langs[lang]) return lang;
  for (const i in langs) {
    if (langs[i].indexOf(lang.toLowerCase()) !== -1) {
      return i;
    }
  }
  return langKeys[0];
}

/**
 *
 * @description 获取底座主语言
 * @returns
 */
async function getMobileLang() {
  let languageCode = navigator.language;
  console.log('languageCode', languageCode)
  // let language = Config.default_language;
  let language = languageCode ? languageCode.split("-")[0] : Config.default_language;
  const la = getLangType(language)
  console.log('la', la)
  localStorage.setItem('locale', la)
  return la;
  // if (process.env.NODE_ENV === "development" || !device.isMission()) {
  // } else {
  //   try {
  //     const data = await window.mx.language();
  //     if (data && data.language) {
  //       return data.language;
  //     }
  //     return langKeys[0];
  //   } catch (err) {
  //     console.error(err);
  //     return langKeys[0];
  //   }
  // }
}

/**
 *
 * @description 根据底座初始化当前语言
 * @export
 * @returns
 */
export async function initLang() {
  const mobileLang = await getMobileLang();
  const langType = getLangType(mobileLang);
  currentLang = langType;

  return langType;
}

/**
 *
 * @description 获取当前主语言
 * @export
 * @returns
 */
export function getLang() {
  return currentLang;
}
